import React, { useState } from "react";
import { useAuth } from "../contex/AuthContext";
import { updateUserProfile } from "../lib/db";

export default function ProfileScreen({ onClose }) {
  const { profile, setProfile, logout, user } = useAuth();
  const [form, setForm] = useState({
    name: profile?.name || "",
    school: profile?.school || "",
    programme: profile?.programme || "",
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    if (!form.name.trim()) { setError("Name is required."); return; }
    setSaving(true);
    setError("");
    try {
      await updateUserProfile({
        name: form.name.trim(),
        school: form.school.trim(),
        programme: form.programme.trim(),
      });
      setProfile(p => ({ ...p, ...form }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      setError("Failed to save. Please try again.");
    }
    setSaving(false);
  };

  return (
    <div style={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={styles.sheet}>
        <div style={styles.handle}/>
        <div style={styles.header}>
          <div style={styles.title}>My Profile</div>
          <button style={styles.closeBtn} onClick={onClose}>×</button>
        </div>

        {/* Avatar */}
        <div style={styles.avatarWrap}>
          <div style={styles.avatar}>{form.name?.[0]?.toUpperCase() || "S"}</div>
          <div style={styles.email}>{user?.email}</div>
          <div style={styles.verifiedBadge}>
            {user?.emailVerified ? "✅ Verified" : "⚠️ Not verified"}
          </div>
        </div>

        {/* Form */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Full name *</label>
          <input style={styles.input} placeholder="Your name"
            value={form.name} onChange={e => setForm({...form, name: e.target.value})}/>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>School / University</label>
          <input style={styles.input} placeholder="e.g. University of Ghana"
            value={form.school} onChange={e => setForm({...form, school: e.target.value})}/>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Programme</label>
          <input style={styles.input} placeholder="e.g. BSc Economics"
            value={form.programme} onChange={e => setForm({...form, programme: e.target.value})}/>
        </div>

        {error && <div style={styles.error}>{error}</div>}
        {saved && <div style={styles.success}>✅ Profile updated successfully!</div>}

        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save changes"}
        </button>

        <button style={styles.logoutBtn} onClick={async () => { await logout(); }}>
          Sign out
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay:     { position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:300, display:"flex", alignItems:"flex-end", justifyContent:"center" },
  sheet:       { background:"var(--modal-bg)", borderRadius:"24px 24px 0 0", padding:"20px 20px 40px", width:"100%", maxWidth:"480px", maxHeight:"90vh", overflowY:"auto" },
  handle:      { width:"38px", height:"4px", background:"var(--surface2)", borderRadius:"2px", margin:"0 auto 18px" },
  header:      { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px" },
  title:       { fontSize:"18px", fontWeight:700, color:"var(--text)" },
  closeBtn:    { background:"var(--surface2)", border:"none", borderRadius:"50%", width:"30px", height:"30px", fontSize:"18px", color:"var(--text)", cursor:"pointer" },
  avatarWrap:  { display:"flex", flexDirection:"column", alignItems:"center", marginBottom:"24px", gap:"6px" },
  avatar:      { width:"72px", height:"72px", borderRadius:"50%", background:"var(--accent)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"28px", fontWeight:700, color:"#fff" },
  email:       { fontSize:"14px", color:"var(--text2)" },
  verifiedBadge:{ fontSize:"12px", color:"var(--text3)" },
  formGroup:   { marginBottom:"14px" },
  label:       { display:"block", fontSize:"12px", fontWeight:600, color:"var(--text2)", textTransform:"uppercase", letterSpacing:".06em", marginBottom:"6px" },
  input:       { width:"100%", padding:"12px 14px", background:"var(--input-bg)", border:"1px solid var(--border2)", borderRadius:"8px", fontFamily:"inherit", fontSize:"14px", color:"var(--text)", outline:"none" },
  error:       { fontSize:"13px", color:"var(--red)", marginBottom:"12px" },
  success:     { fontSize:"13px", color:"var(--green)", marginBottom:"12px", fontWeight:500 },
  saveBtn:     { width:"100%", padding:"14px", background:"var(--accent)", border:"none", borderRadius:"12px", fontFamily:"inherit", fontSize:"15px", fontWeight:600, color:"#fff", cursor:"pointer", marginBottom:"10px" },
  logoutBtn:   { width:"100%", padding:"12px", background:"transparent", border:"1px solid var(--border2)", borderRadius:"12px", fontFamily:"inherit", fontSize:"14px", color:"var(--text2)", cursor:"pointer" },
};